<template>
  <v-text-field
    ref="textFieldRef"
    v-model="model"
    color="primary"
    density="compact"
    variant="outlined"
  />
</template>

<script setup lang="ts">
import { VTextField } from 'vuetify/components'
import { ref } from 'vue'

defineOptions({
  name: 'SfTextField'
})

const textFieldRef = ref<VTextField>()
defineExpose({
  focus: () => textFieldRef.value?.focus()
})

const [model, modifiers] = defineModel<string | number | null>({
  set(value): string | number | null {
    if (!modifiers.noFixSpaces && typeof value === 'string') {
      return value.trim().replace(/\s{2,}/g, ' ')
    }
    return value
  }
})
</script>
